import styled from "@emotion/styled";

export const StyledProductTagsComponent = styled.div`
  height: 350px;
  .additional-button-text {
    margin-top: 16px;
  }
`;
